import React from "react";
import AmountPerCategory from "../pieChart/AmountPerCategory";

export default function CategoryDetails(props) {
    const items = parseCategorySummaryItems(props.items);

    function parseCategorySummaryItems(items) {
        return items.map((item) => {
            return {
                id: item.categoryId,
                name: item.category,
                value: item.amount,
                percentageDiff: item.diffInPercentage
            };
        });
    }

    const categoryWasClicked = (categoryId, categoryDescription) => {
        props.categoryWasClicked(categoryId, categoryDescription);
    };

    return (
        <div style={{ height: props.height || "260px" }}>
            {items.length ? (
                <AmountPerCategory
                    items={items}
                    height={props.height}
                    categorySelected={(categoryId, categoryDescription) =>
                        categoryWasClicked(categoryId, categoryDescription)
                    }
                />
            ) : (
                ""
            )}
        </div>
    );
}
